'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _Toolbar = require('@material-ui/core/Toolbar');

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Grid = require('@material-ui/core/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _styles = require('@material-ui/core/styles');

var _withWidth = require('@material-ui/core/withWidth');

var _withWidth2 = _interopRequireDefault(_withWidth);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _styles2 = require('./styles');

var _styles3 = _interopRequireDefault(_styles2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO find a way to better overwrite the items styles
var style = {
  item: {
    padding: '0px'
  }
};

var TwoRowsAppBar = function (_React$PureComponent) {
  _inherits(TwoRowsAppBar, _React$PureComponent);

  function TwoRowsAppBar() {
    _classCallCheck(this, TwoRowsAppBar);

    return _possibleConstructorReturn(this, (TwoRowsAppBar.__proto__ || Object.getPrototypeOf(TwoRowsAppBar)).apply(this, arguments));
  }

  _createClass(TwoRowsAppBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          topLeftContent = _props.topLeftContent,
          topCenterContent = _props.topCenterContent,
          topRightContent = _props.topRightContent,
          bottomLeftContent = _props.bottomLeftContent,
          bottomCenterContent = _props.bottomCenterContent,
          bottomRightContent = _props.bottomRightContent,
          width = _props.width,
          _props$smallScreenWid = _props.smallScreenWidth,
          smallScreenWidth = _props$smallScreenWid === undefined ? 'xs' : _props$smallScreenWid;


      var smallScreen = (0, _withWidth.isWidthDown)(smallScreenWidth, width);

      return React.createElement(
        _Toolbar2.default,
        null,
        React.createElement(
          _Grid2.default,
          { container: true, direction: 'column', className: classes.wrapper, spacing: 16 },
          React.createElement(
            _Grid2.default,
            {
              container: true,
              className: (0, _classnames2.default)(classes.row, classes.topRow),
              justify: 'space-between',
              spacing: 16
            },
            React.createElement(
              _Grid2.default,
              { item: true, style: style.item, xs: 2, sm: 4, md: 3, lg: 2, className: classes.left },
              topLeftContent
            ),
            React.createElement(
              _Grid2.default,
              {
                item: true,
                style: style.item,
                xs: 8,
                sm: 4,
                md: 6,
                lg: 8,
                className: (0, _classnames2.default)(classes.topCenter, _defineProperty({}, '' + classes.centerBig, !smallScreen))
              },
              topCenterContent
            ),
            React.createElement(
              _Grid2.default,
              { item: true, style: style.item, xs: 2, sm: 4, md: 3, lg: 2, className: classes.right },
              topRightContent
            )
          ),
          React.createElement(
            _Grid2.default,
            {
              container: true,
              className: (0, _classnames2.default)(classes.row, classes.bottomRow),
              justify: 'space-between',
              spacing: 16
            },
            React.createElement(
              _Grid2.default,
              { item: true, style: style.item, xs: 2, sm: 4, md: 3, lg: 2, className: classes.left },
              bottomLeftContent
            ),
            React.createElement(
              _Grid2.default,
              {
                item: true,
                style: style.item,
                xs: 8,
                sm: 4,
                md: 6,
                lg: 8,
                className: (0, _classnames2.default)(classes.bottomCenter, _defineProperty({}, '' + classes.centerBig, !smallScreen))
              },
              bottomCenterContent
            ),
            React.createElement(
              _Grid2.default,
              { item: true, style: style.item, xs: 2, sm: 4, md: 3, lg: 2, className: classes.right },
              bottomRightContent
            )
          )
        )
      );
    }
  }]);

  return TwoRowsAppBar;
}(React.PureComponent);

TwoRowsAppBar.defaultProps = {
  classes: {},
  topLeftContent: null,
  topCenterContent: null,
  topRightContent: null,
  bottomLeftContent: null,
  bottomCenterContent: null,
  bottomRightContent: null,
  smallScreenWidth: 'xs'
};
exports.default = (0, _compose2.default)((0, _withWidth2.default)(), (0, _styles.withStyles)(_styles3.default))(TwoRowsAppBar);


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-layout/lib/templates/AppBar/TwoRowsAppBar/TwoRowsAppBar.js
// module id = 617
// module chunks = 61549186969478 79611799117203